<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">采购商</span>
            <el-input
              v-model="listQuery.name"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">审批状态</span>
            <el-select :filterable="true" v-model="listQuery.changeStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in ReviewStatusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <TableList
        ref="tableListRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :isShowPagination="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :highlightCurrentRow="true"
        @command-change="handleCommand"
      >
        <template v-slot:name="scope">
          <span :class="scope.row.status === 1 ? 'redStatusStyle' : scope.row.status === 2 ? 'yellowStatusStyle' : ''" class="statusStyle">
            <i class="iconfont icon-tubiao-40" v-if="scope.row.status !== 3"></i>
            <span class="status">{{ReviewStatusOption.find(k => k.id === scope.row.status) ? ReviewStatusOption.find(k => k.id === scope.row.status).mark : ''}} </span>

            <span>{{scope.row.name}} </span>
          </span>
        </template>

        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_APPROVAL` }"
            v-if="listQuery.changeStatus !== 3"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            审批
          </el-link>
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <div v-if="dialogFormVisible">
      <div style="display:flex">
        <FormComponent
          v-if="!firstApproval"
          :id="activeId"
          :initFormData="initFormData"
          :fromFieldData="originFromFieldData"
          :dialogFormVisible="dialogFormVisible"
          :api="'outsourceCompany'"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          :formDisabled="true"
          :canAdd="false"
        />
        <FormComponent
          :id="activeId"
          :initFormData="initFormData"
          :fromFieldData="targetFromFieldData"
          :dialogFormVisible="dialogFormVisible"
          :api="'outsourceCompany'"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          :formDisabled="true"
          :canAdd="false"
        />
      </div>
      <div class="dialog-footer mt-20">
        <el-button @click="dialogFormVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit('approve')"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          :loading="submitLoading"
          @click="handleSubmit('reject')"
        >
          拒绝
        </el-button>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { cloneDeep } from 'lodash'
import { reviewsupplierById, getReviewCompanyList, reviewApprove, reviewReject } from '@/apis/Supplier'
import { getDropdown } from '@/apis/Dictionary'
import { getPageList } from '@/apis/Form'
import { getDropdownByType } from '@/apis/tool'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '@/views/supplier/FieldFrom'
import { TableField } from './FieldTable'
import mixin from '@/mixins/index'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Approvalsupplier',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref(null)
    const dataMap = reactive({
      TableName: TableName.TABLE_APPROVAL_SUPPLIER,
      permissionName: permissionName.APPROVAL_SUPPLIER,
      initFormData: cloneDeep(FromFieldData),
      originFromFieldData: cloneDeep(FromFieldData),
      targetFromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        contactNumber: undefined,
        contactName: undefined,
        contactPhone: undefined,
        changeStatus: undefined,
        ...pageVo,
        startTime: '',
        endTime: ''
      },
      pageSizes,
      dialogFormVisible: false,

      activeTab: 1,

      ReviewStatusOption: [],
      firstApproval: false,

      submitLoading: false,
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getReviewCompanyList(dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          contactNumber: undefined,
          contactName: undefined,
          contactPhone: undefined,
          changeStatus: undefined,
          ...pageVo,
          startTime: defaultDate[0],
          endTime: defaultDate[1]
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const {
          startTime,
          endTime
        } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.originFromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.targetFromFieldData = cloneDeep(dataMap.initFormData)
        reviewsupplierById(row.id).then((res: any) => {
          dataMap.firstApproval = res.newItem

          const target = res.target
          dataMap.handleResolveData(dataMap.targetFromFieldData, target)
          if (!dataMap.firstApproval) {
            const origin = res.origin

            dataMap.handleResolveData(dataMap.originFromFieldData, origin)
            dataMap.originFromFieldData.forEach((item: any, index: any) => {
              dataMap.handleComparData(item.formList, dataMap.targetFromFieldData[index].formList, item.title)
            })
          }
          dataMap.dialogFormVisible = true
        })
      },
      // 数据处理成表单
      handleResolveData(fromFieldData: any, target: any) {
        fromFieldData.forEach((k: any) => {
          if (k.type === 1) {
            k.formList.forEach((field: any) => {
              field.value = target[field.fieldKey] || field.value
              switch (field.fieldKey) {
                case 'address':
                  field.value = target.address ? target.address.split('-') : ''
                  break
              }
            })
          } else if (k.type === 2) {
            const { accounts } = target
            const addContions = k.formList
            const _arr = [] as ArrayRowsItem
            if (addContions) {
              accounts.forEach((item: any) => {
                const _copyContion = cloneDeep(addContions)[0]
                _copyContion.id = item.id
                Object.keys(item).forEach(k => {
                  _copyContion.list?.forEach((j: any) => {
                    if (j.fieldKey === k) {
                      j.value = item[k] || j.value
                    }
                  })
                })
                _arr.push(_copyContion)
              })
              k.formList = _arr
            }
          }
        })
      },
      // 对比处理数据特殊颜色
      handleComparData(originFromList: any, targetFromList: any, title: any) {
        if (title !== '账户信息') {
          originFromList.forEach((item: any) => {
            targetFromList.forEach((k: any) => {
              if (item.fieldKey === k.fieldKey) {
                const _originValue = item.value ? item.value.toString() : item.value
                const _targetValue = k.value ? k.value.toString() : k.value
                if (_originValue !== _targetValue) {
                  item.config.colorTheme = 1
                  k.config.colorTheme = 2
                }
              }
            })
          })
        } else {
          originFromList.forEach((item: any, index: any) => {
            dataMap.handleComparData(item.list, targetFromList[index]?.list || [], item.title)
          })
        }
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      getDropdownByType(url: string) {
        getDropdownByType('ReviewStatus').then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },

      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 2 && column.url) {
            getPageList(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          } else if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      async handleSubmit(type: string) {
        try {
          if (type === 'reject') {
            ElMessageBox.prompt(
              '请输入原因：',
              '提交',
              {
                confirmButtonText: t('table.confirm'),
                cancelButtonText: t('table.cancel'),
                cancelButtonClass: 'el-button--danger'
              }
            ).then(async(params: any) => {
              const { value } = params
              await reviewReject(dataMap.activeId, { comment: value })
              dataMap.getList()
              dataMap.dialogFormVisible = false
              ElMessage.success('操作成功！')
            })
          } else if (type === 'approve') {
            await reviewApprove(dataMap.activeId)
            dataMap.dialogFormVisible = false
            dataMap.getList()
            ElMessage.success('操作成功！')
          }
        } catch (err:any) {
          console.log(222)
        }
      }

    })
    const { mixinData } = mixin(dataMap)

    onMounted(async() => {
      // await dataMap.loadTableSelectOption()
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.loadDropdownList('customerLevel')
      dataMap.loadDropdownList('customerSource')
      dataMap.loadDropdownList('paymentCycle')
      dataMap.getDropdownByType('ReviewStatus')
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableListRef }
  }
})
</script>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
</style>
